// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"ebac79e0","246":"6d3a455f","355":"5f44b144","696":"8b37a926","787":"749b4a44","931":"621814a5"}[chunkId] + ".chunk.js";
};